"use client";
import { Analytics } from "@vercel/analytics/next";
import { useSyncExternalStore } from "react";
import { usePathname } from "next/navigation";
import { AnonymousConsentControls } from "@dj/site-navigation/anonymous-analytics-react";
import { analyticsConsent,analyticsConsentChanged,resolveCookieScope } from "@dj/site-navigation/anonymous-analytics";
import { anonymousAnalyticsSettings } from "@/lib/anonymousAnalyticsSettings";
import { LandingLegacyAnalyticsConsentControls } from "./LandingLegacyAnalyticsConsentControls";

const subscribeConsent = (notify:()=>void) => {window.addEventListener(analyticsConsentChanged,notify);window.addEventListener("focus",notify);return()=>{window.removeEventListener(analyticsConsentChanged,notify);window.removeEventListener("focus",notify);};};
const readScope = () => Boolean(resolveCookieScope({...anonymousAnalyticsSettings,hostname:window.location.hostname,protocol:window.location.protocol}));
const readConsent = () => analyticsConsent(document.cookie,anonymousAnalyticsSettings.environment === "staging" ? "staging" : "development") === "granted";

export function LandingAnalyticsConsentControls({analyticsAvailable,vercelAnalyticsAvailable}:{analyticsAvailable:boolean;vercelAnalyticsAvailable:boolean}) {
  const granted=useSyncExternalStore(subscribeConsent,readConsent,()=>false);
  const sharedScope=useSyncExternalStore<boolean|null>(subscribeConsent,readScope,()=>null);
  const path=usePathname()??"/";const locale=path.split("/")[1];
  // Retain the previously approved consent/Vercel UI outside the new lane's
  // verified host scope. That fallback cannot activate the v2 producer.
  if(sharedScope===null)return null;
  if(!sharedScope)return <LandingLegacyAnalyticsConsentControls analyticsAvailable={analyticsAvailable} vercelAnalyticsAvailable={vercelAnalyticsAvailable}/>;
  // Local consent behavior is reviewable with collection disabled. Production
  // parent-domain trust remains gated in the shared scope resolver.
  return <>{vercelAnalyticsAvailable&&granted?<Analytics/>:null}<AnonymousConsentControls settings={anonymousAnalyticsSettings} locale={locale}/></>;
}
